import { EditorState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';
import _ from 'lodash';
import isHtml from 'is-html';
import { markdownToRawMarkup } from './html-utils';

export const getContentStateAsHTML = (draftContent) =>
    draftContent
        ? stateToHTML(draftContent, {
              blockRenderers: {
                  atomic: (block) => {
                      try {
                          const entityKey = block?.getEntityAt(0);
                          const entity = draftContent?.getEntity(entityKey);
                          const data = entity?.getData();
                          const type = entity?.getType();
                          const alignment = data?.alignment;
                          const className = `description-align-${alignment || 'normal'}`;

                          if (type === 'draft-js-video-plugin-video') {
                              return `<figure><iframe class='${className}' width='560' height='315'  src='${
                                  data.src
                              }' frameborder='0' allowfullscreen allow='fullscreen' loading='lazy'>${'\xA0'}</iframe></figure>`;
                          } else if (type === 'IMAGE') {
                              if (data.width) {
                                  return `
                                <figure>
                                    <img class='${className}' src='${data.src}' width='${data.width}%' alt='' loading='lazy' />
                                </figure>
                                `;
                              }

                              return `
                                <figure>
                                    <img class='${className}' src='${data.src}' alt='' loading='lazy' />
                                </figure>
                                `;
                          }
                      } catch (err) {
                          return '';
                      }
                  },
              },
          })
        : '';

const alignmentMap = {
    'description-align-center': 'center',
    'description-align-left': 'left',
    'description-align-right': 'right',
};

const stateFromHTMLOptions = {
    customInlineFn: (element, { Entity }) => {
        if (element.tagName === 'IMG') {
            const alignment = alignmentMap[element.getAttribute('class')];
            let width = element.getAttribute('width');
            width = width ? `${parseInt(width, 10)}` : undefined;
            const src = element.getAttribute('src');
            const alt = element.getAttribute('alt');
            const loading = element.getAttribute('loading');
            const role = element.getAttribute('role');
            const data = { src, alignment, width, alt, loading, role };
            return Entity('IMAGE', _.pickBy(data), 'IMMUTABLE');
        }

        if (element.tagName === 'IFRAME') {
            return Entity(
                'draft-js-video-plugin-video',
                { src: element.getAttribute('src'), loading: element.getAttribute('loading') },
                'IMMUTABLE'
            );
        }
    },
};

export const getAsDraftContent = (description) => {
    if (!description || typeof document === 'undefined') {
        return null;
    } else if (isHtml(description)) {
        const state = stateFromHTML(description, stateFromHTMLOptions);
        return EditorState.createWithContent(state);
    }
    const rawMarkup = markdownToRawMarkup(description);
    return EditorState.createWithContent(stateFromHTML(rawMarkup.__html, stateFromHTMLOptions));
};

export const contentStateIsEmpty = (contentStateAsHTML) => {
    return contentStateAsHTML === '<p><br></p>' || !contentStateAsHTML;
};

export const descriptionIsEmpty = (description) => {
    return description === '<p><br /></p>' || !description;
};
